/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsLine: {
  name: 'line';
  data: string;
} = {
  name: 'line',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path fill-rule="evenodd" clip-rule="evenodd" d="M9.5 1a.5.5 0 0 0 .5.5h2.793L1.646 12.646a.5.5 0 0 0 .708.708L13.5 2.207V5a.5.5 0 0 0 1 0V1a.5.5 0 0 0-.5-.5h-4a.5.5 0 0 0-.5.5Zm5 9a.5.5 0 0 0-1 0v5a.5.5 0 0 0 1 0v-5Zm-4 2a.5.5 0 0 0-1 0v3a.5.5 0 0 0 1 0v-3ZM6 13.5a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-1 0v-1a.5.5 0 0 1 .5-.5Z" fill="currentColor"/></svg>`,
};
